// Persisted customBanks schema: depositCondition = all | gte | lt, depositThreshold in baht.
// Keep this contract aligned with the Admin app's customBankRules utility.
export const readDepositAmount = value => {
  if (typeof value !== 'number' && typeof value !== 'string') return null
  if (typeof value === 'string' && !value.trim()) return null
  const amount = Number(value)
  return Number.isFinite(amount) && amount >= 0 ? amount : null
}

export const getDepositCondition = bank => {
  const condition = bank && bank.depositCondition
  return condition === undefined || condition === null ? 'all' : condition
}

export const isCustomBankRuleValid = bank => {
  const condition = getDepositCondition(bank)
  if (condition === 'all') return true
  return ['gte', 'lt'].includes(condition) && readDepositAmount(bank.depositThreshold) !== null
}

export const getEligibleCustomBanks = (banks, depositTotal) => {
  const list = Array.isArray(banks) ? banks : Object.values(banks || {})
  // Users with no deposit total yet are new users; malformed totals are not treated as zero.
  const total = readDepositAmount(depositTotal === undefined || depositTotal === null ? 0 : depositTotal)
  return list.filter(bank => {
    if (!bank || bank.enabled === false || !bank.bankCode || !bank.accountno) return false
    const condition = getDepositCondition(bank)
    if (condition === 'all') return true
    if (total === null || !isCustomBankRuleValid(bank)) return false
    const threshold = readDepositAmount(bank.depositThreshold)
    return condition === 'gte' ? total >= threshold : total < threshold
  })
}
